module.exports = __webpack_public_path__ + "media/video1.8232b97c.mp4";